import { List } from 'immutable';
import { lruMemoize } from 'reselect';

import {
    isResourceLoading,
    getResourceTotal,
    getResourcePage,
} from './common';

const isProductUpdatesLoading = lruMemoize(isResourceLoading);
const getProductUpdatesTotal = getResourceTotal;
const getProductUpdatesPage = getResourcePage;
const getProductUpdates = lruMemoize(
    (data) => data.get('product_updates', List()),
);

const isFeaturedProductUpdatesLoading = lruMemoize(isResourceLoading);
const getFeaturedProductUpdates = lruMemoize(
    (data) => data.get('productUpdates', List()),
);

export {
    isFeaturedProductUpdatesLoading,
    isProductUpdatesLoading,
    getFeaturedProductUpdates,
    getProductUpdatesTotal,
    getProductUpdatesPage,
    getProductUpdates,
};
